import { render } from "./CardBorder.vue?vue&type=template&id=a90d96f4"
import script from "./CardBorder.vue?vue&type=script&lang=ts"
export * from "./CardBorder.vue?vue&type=script&lang=ts"
script.render = render

export default script